import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Tag, Typography, Form, Input, Select, Drawer,
  Upload, Cascader, Alert, message,
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, InboxOutlined, InfoCircleOutlined, DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const categoryOptions = [
  {
    label: '摄像机', value: '1',
    children: [
      { label: '室内摄像机', value: '1-1', children: [{ label: '云台摄像机 (Wi-Fi)', value: '112' }] },
      { label: '户外摄像机', value: '1-2', children: [{ label: '长电枪机 (Wi-Fi)', value: '121' }] },
      { label: '4G智能摄像机', value: '1-3', children: [{ label: '电池枪机 (4G)', value: '133' }] },
    ],
  },
  { label: '网关类', value: '2', children: [{ label: 'HUB', value: '21' }] },
  { label: '存储类', value: '3', children: [{ label: 'NVR', value: '31' }] },
];

const STATUS_MAP = {
  developing: { text: '开发中', color: 'orange' },
  releasing: { text: '发布中', color: 'blue' },
  published: { text: '已发布', color: 'green' },
  failed: { text: '发布失败', color: 'red' },
};

// TODO: 联调时替换为接口数据
const MOCK_PLANS = [
  {
    key: '1', productName: '智能云台摄像机方案', productId: 'P_ECO_001', category: '摄像机',
    status: 'published', testQuota: 10, productionQuota: 2000, producedNum: 1200,
    operator: 'heying2025', createTime: '2026-04-20', childCount: 3,
  },
  {
    key: '2', productName: '4G低功耗电池摄像机方案', productId: 'P_ECO_002', category: '摄像机',
    status: 'published', testQuota: 10, productionQuota: 500, producedNum: 320,
    operator: 'heying2025', createTime: '2026-04-18', childCount: 1,
  },
  {
    key: '3', productName: '智能门铃方案', productId: 'P_ECO_003', category: '摄像机',
    status: 'developing', testQuota: 10, productionQuota: 0, producedNum: 0,
    operator: 'admin', createTime: '2026-04-15', childCount: 0,
  },
  {
    key: '4', productName: 'NVR网络录像机方案', productId: 'P_ECO_004', category: '存储类',
    status: 'releasing', testQuota: 10, productionQuota: 0, producedNum: 0,
    operator: 'admin', createTime: '2026-04-10', childCount: 0,
  },
];

const PlanDevelop = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [createForm] = Form.useForm();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleCreate = async () => {
    try {
      await createForm.validateFields();
    } catch {
      return;
    }
    message.success('方案产品已创建，进入开发');
    setDrawerVisible(false);
    navigate('/product/develop');
  };

  const columns = [
    {
      title: '方案产品', key: 'productInfo', width: 240,
      render: (_, r) => (
        <div>
          <div
            style={{ color: '#1890ff', cursor: 'pointer', fontWeight: 500 }}
            onClick={() => navigate('/product/info', { state: { name: r.productName, id: r.productId, category: r.category } })}
          >
            {r.productName}
          </div>
          <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.productId}</Text>
        </div>
      ),
    },
    {
      title: '产品类型', key: 'type', width: 100,
      render: () => <Tag color="purple" style={{ border: 'none' }}>方案产品</Tag>,
    },
    { title: '产品类目', dataIndex: 'category', width: 150 },
    {
      title: '产品状态', dataIndex: 'status', width: 100,
      render: (v) => <Tag color={STATUS_MAP[v]?.color}>{STATUS_MAP[v]?.text || v}</Tag>,
    },
    {
      title: '关联整机数', dataIndex: 'childCount', width: 110, align: 'right',
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: '赠送授权', dataIndex: 'testQuota', width: 120,
      render: (_, r) => (
        <div style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
          <div>测试授权：{r.testQuota || 0}个</div>
          <div>生产授权：{r.productionQuota || 0}个</div>
        </div>
      ),
    },
    { title: '采购生产授权', dataIndex: 'producedNum', key: 'producedNum', width: 120 },
    { title: '操作人', dataIndex: 'operator', width: 120 },
    { title: '创建时间', dataIndex: 'createTime', width: 120 },
    {
      title: '操作', key: 'action', fixed: 'right', width: 280,
      render: (_, r) => (
        <Space size={4}>
          {(r.status === 'developing' || r.status === 'failed') && (
            <Button type="link" size="small" onClick={() => navigate('/product/develop')}>继续开发</Button>
          )}
          {r.status !== 'developing' && (
            <Button type="link" size="small" onClick={() => navigate(`/firmware/version?productId=${r.productId}&productName=${encodeURIComponent(r.productName)}`)}>管理固件</Button>
          )}
          {r.status === 'published' && (
            <Button type="link" size="small" onClick={() => navigate('/product/my-solutions')}>开放方案</Button>
          )}
          <Button type="link" size="small" icon={<DownOutlined style={{ fontSize: 10 }} />}>更多</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Title level={4} style={{ margin: 0 }}>方案开发</Title>
        <Tag color="purple" style={{ border: 'none' }}>方案产品（PCBA）</Tag>
      </div>

      <Alert
        type="info"
        showIcon
        closable
        style={{ marginBottom: 16, borderRadius: 8 }}
        message="方案产品（PCBA）用于被多个整机产品引用派生；方案产品可采购授权、可开放到合作企业或生态方案库。"
      />

      <Card bordered={false} style={{ marginBottom: 16, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form form={form} layout="inline" style={{ rowGap: 12 }}>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space.Compact>
              <Form.Item name="prodType" noStyle initialValue="name">
                <Select style={{ width: 100 }}>
                  <Option value="name">产品名称</Option>
                  <Option value="id">产品ID</Option>
                </Select>
              </Form.Item>
              <Form.Item name="prodValue" noStyle>
                <Input placeholder="请输入方案产品" allowClear style={{ width: 200 }} />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item name="status" style={{ marginBottom: 0 }}>
            <Select placeholder="产品状态" allowClear style={{ width: 140 }}
              options={Object.entries(STATUS_MAP).map(([value, v]) => ({ value, label: v.text }))} />
          </Form.Item>
          <Form.Item name="category" style={{ marginBottom: 0 }}>
            <Cascader options={categoryOptions} placeholder="产品类目" allowClear changeOnSelect style={{ width: 160 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card bordered={false} style={{ borderRadius: 12 }}>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setDrawerVisible(true)}>创建方案产品</Button>
        </div>
        <Table
          columns={columns}
          dataSource={MOCK_PLANS}
          rowKey="key"
          scroll={{ x: 1400 }}
          style={{ whiteSpace: 'nowrap' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Card>

      <Drawer
        title="创建方案产品"
        width={560}
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        footer={(
          <div style={{ textAlign: 'right', padding: '10px 16px' }}>
            <Space>
              <Button onClick={() => setDrawerVisible(false)}>取消</Button>
              <Button type="primary" onClick={handleCreate}>保存并开发</Button>
            </Space>
          </div>
        )}
      >
        <Form form={createForm} layout="vertical">
          <Form.Item name="category" label="产品类目" rules={[{ required: true, message: '请选择产品类目' }]}>
            <Cascader options={categoryOptions} placeholder="请选择三级产品类目" expandTrigger="hover" />
          </Form.Item>
          <Form.Item name="name" label="方案产品名称" rules={[{ required: true, message: '请输入方案产品名称' }]}>
            <Input placeholder="请输入方案产品名称" maxLength={40} showCount />
          </Form.Item>
          <Form.Item name="model" label="产品型号">
            <Input placeholder="请输入产品型号" maxLength={40} showCount />
          </Form.Item>
          <Form.Item
            name="image"
            label={<span>产品图 <InfoCircleOutlined style={{ color: '#8c8c8c' }} /></span>}
          >
            <Upload.Dragger beforeUpload={() => false} maxCount={1}>
              <p className="ant-upload-drag-icon"><InboxOutlined /></p>
              <p className="ant-upload-text">拖拽图片到这或者点击上传</p>
              <p className="ant-upload-hint">最多可上传 1 个文件</p>
            </Upload.Dragger>
          </Form.Item>
          <Form.Item name="description" label="方案描述">
            <TextArea rows={4} placeholder="请输入方案描述" maxLength={200} showCount />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default PlanDevelop;
